export const NOT_STORABLE_FIELDS = `
    vat
    inclTax
    exclTax
    purchasePrice
`;
